export default "__VITE_ASSET__JzXQ$Iy3__"